/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRecommendationsTenantResponse {
    getFixupPrototypeFunction() { return ListRecommendationsTenantResponse.fixupPrototype; }

    static newInstance(model: Partial<ListRecommendationsTenantResponse>): ListRecommendationsTenantResponse {
        let obj = Object.assign(new ListRecommendationsTenantResponse(), model);
        ListRecommendationsTenantResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRecommendationsTenantResponse>): ListRecommendationsTenantResponse {
        if (!model) return null;
        return ListRecommendationsTenantResponse.newInstance(<ListRecommendationsTenantResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRecommendationsTenantResponse) {
        if (!obj) return;

        models.ListRecommendationsTenantResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRecommendationsTenantResponse): boolean {
        Object.setPrototypeOf(obj, ListRecommendationsTenantResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.recommendations) {
            for (let val of this.recommendations) {
                models.RecommendationTenant.fixupPrototype(val);
            }
        }
    }

    /**
     * Total count
     */
    total_count: number;

    /**
     * Page count
     */
    page_count: number;

    /**
     * Recommendations
     */
    recommendations: Array<models.RecommendationTenant>;

}
